import i18next from "i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProduct, getAllProducts } from "../../REDUX/actions/products";
import CustomButton from "../Common/CustomButton";
import EmptyList from "../Common/EmptyList";
import Loading from "../Common/Loading";
import InputText from "../sectioninput/formelement/InputText";
import ProductCard from "./ProductCard";
import { useProductsFR } from "../../hooks/product-fr";
import ProductCardFR from "./ProductCardFR";

const ProductList = () => {
  const dispatch = useDispatch();
  const [filter, setfilter] = useState("");
  const {
    products: productsFR,
    createProduct,
    deleteProduct,
    duplicateProduct,
  } = useProductsFR(true);

  const { productsLoading, products } = useSelector(
    (state) => state.productsReducer
  );

  const filterProducts = () => {
    dispatch(getAllProducts(filter));
  };

  const handleAddProduct = () => dispatch(addProduct());

  return !products ? (
    <Loading />
  ) : (
    <div className="bg-white rounded-10 container-fluid p-5 shadowed">
      <div className="row f24 align-items-center">Liste des produits</div>
      <div className="row gx-2 align-items-center mt-2">
        <div className="col-5 d-flex align-items-center">
          <InputText
            flag={false}
            placeholder="rechercher un produit"
            handleChange={setfilter}
          />
          <div className="ms-3 col-1">
            <CustomButton
              iconStart={"search"}
              callBack={() => filterProducts(filter)}
            />
          </div>
        </div>

        <div className="col-3">
          <CustomButton
            buttonText={
              i18next.language !== "fr"
                ? "Passez en langue principale"
                : "Ajouter un produit"
            }
            iconStart={"plus-lg"}
            callBack={handleAddProduct}
            disabled={i18next.language !== "fr"}
          />
        </div>
        <div className="col-4">
          <CustomButton
            buttonText={
              i18next.language !== "fr"
                ? "Passez en langue principale"
                : "Ajouter un produit français"
            }
            iconStart={"plus-lg"}
            callBack={createProduct}
            disabled={i18next.language !== "fr"}
          />
        </div>
      </div>
      {!productsLoading ? (
        <div className="mt-5 d-flex gap-5 flex-wrap justify-content-around">
          {productsFR?.map((product, index) => (
            <ProductCardFR
              key={index}
              product={product}
              deleteProduct={deleteProduct}
              duplicateProduct={duplicateProduct}
            />
          ))}
          {products?.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
          {!products.length && !productsFR.length && (
            <div className="w-100">
              <EmptyList text="Ajouter votre premier produit" />
            </div>
          )}
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default ProductList;
